<template>
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="56" height="56" rx="28" fill="var(--player-contrast)"/>
        <path d="M25.8207 20.209L35.5593 27.2567C36.3374 27.8194 36.3374 29.1814 35.5593 29.7442L25.8207 36.7918C25.0198 37.3705 24 36.6743 24 35.5473V21.4521C24 20.3251 25.0198 19.6289 25.8207 20.209Z" fill="var(--player-background)"/>
    </svg>
</template>
